import * as types from '../constants/ActionTypes'

import 'whatwg-fetch';

const server = window.server || "";

export const getApps = (nextPage) => {
	return (dispatch,getState) => {
		const {apps} = getState();
		//console.log("apps:",apps);
		!sessionStorage.csmApps && dispatch({type:types.PAGE_LOADING,pageLoading:true});
		fetch(server + "/v1.1/app?" + getParams(apps.params),{
			method: 'GET'
		}).then(function(response) {
			return response.json();
		}).then(function(data) {
			//console.log("datas:",datas);
			setTimeout(function() {
				dispatch({type:types.PAGE_LOADING,pageLoading:false});
				dispatch({type:types.GET_APPS,list:data.apps,count:data.count,nextPage});
			}, 300);
		}).catch(function(ex) {
			console.log('parsing failed', ex)
		});
		//dispatch({type: ifShow?types.SHOW_ATMODAL:types.HIDE_ATMODAL});
	}
}

export const initApps = ()=>{
	return (dispatch,getState) => {
		//dispatch({type:types.GO_PAGE,current:1});
		const {apps} = getState();
		if(apps.count===0) 
			dispatch(getApps());
		dispatch(getAppModule());
        dispatch(getAppInd());
	}
}

export const goNextPage = ()=> {
	return (dispatch,getState) => {
		const {apps} = getState();
		if(apps.params.current<=apps.maxPage) {
			//console.log("params:",apps.params);
			dispatch({type:types.GO_PAGE,current:apps.params.current+1});
			dispatch(getApps(true));
		}
	}
}

export const getAppModule = () => {
	return (dispatch,getState) => {
		const params = getParams({
			type: "n",
			gorder: 0}); 
		fetch(server + "/v1.1/sys/genre?" + params,{
			method: 'GET'
		}).then(function(response) {
			return response.json();
		}).then(function(data) {
			//console.log("moduleDatas:",data.genre);
			dispatch({type:types.GET_MODULE,moduleDatas:data.genre});
		}).catch(function(ex) {
			console.log('parsing failed', ex)
		});
	}
}

export const getAppInd = () => {
	return (dispatch,getState) => {
		const params = getParams({
			type: "y",
			gorder: 0}); 
		fetch(server + "/v1.1/sys/genre?" + params,{
			method: 'GET'
		}).then(function(response) {
			return response.json();
		}).then(function(data) {
			//console.log("indDatas:",data.genre);
			dispatch({type:types.GET_IND,indDatas:data.genre});
		}).catch(function(ex) {
			console.log('parsing failed', ex)
		});
	}
}

export const doFliter = (params) => {
	return (dispatch,getState) => {
		dispatch({type:types.DO_FLITER,params});
		let filter = ["module","ind","type"];
		filter.map(f=>{
			!!params[f] && dispatch(doMenuChange(f));
			params[f] == "" && dispatch(doMenuChange())
		});
		dispatch({type:types.GO_PAGE,current:1});
		dispatch(getApps());
	}
}

export const doMenuChange = (target) => {
	return (dispatch,getState) => {
		const {apps} = getState();
		const openFliter = apps.openFliter===target?"":target;
		dispatch({type:types.SET_MENU,openFliter});
	}
}

export const resetParams = () =>{
	return {type:types.RESET_PARAMS}
}

function getParams(data) {
	var result = [];
	for (var key in data) {
		if (data.hasOwnProperty(key)) {
			result.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
		}
	}
	return result.join("&");
}
//重置应用列表图标高度
export const resetHeight = height =>{
	return {type:types.RESET_HEIGHT,data:height}
}

//记录列表滚动位置
export const resetScrollTop = top =>{
	return {type:types.RESET_SCROLLTOP,data:top}
}


// WEBPACK FOOTER //
// ./project/actions/apps.js